import { useState, useEffect, useRef } from "react";
import { FiX } from "react-icons/fi";
import { MdAdd } from "react-icons/md";
import ModalImage from "react-modal-image";
import { useSelector } from "react-redux";
export default function AddProduct({onSave, onCancel, editingProduct}) {
  const user = useSelector((state) => state.auth.user);
  // const dispatch = useAppDispatch();
  const imageRef = useRef(null);
  // const [loading, setLoading] = useState(false);
  // const [bErrors, setBErrors] = useState({});
  const [formData, setFormData] = useState({
    productName: "",
    category: "",
    subCategory: "",
    type: "physical",
    price: 0,
    discountPrice: 0,
    stock: 0,
    sku: "",
    variants: { sizes: [], colors: [] },
    images: [],
    description: "",
    status: "draft",
    taxCategory: "",
    shipping: {
      weight: 0,
      dimensions: { length: 0, width: 0, height: 0 },
      shippingCost: 0,
      shippingTime: "",
      shippingNote: "",
      shippingOrigin: "",
    },
    seo: {
      title: "",
      description: "",
      keywords: "",
    },
  });

  // const handleFetchDetails = async (e) => {
  //   e.preventDefault();
  //   setLoadingForm(true);
  //   const res = await getStripeStatus(user?._id);
  //   if(res?.status === 200){
  //     setBErrors({'Response': res?.message})
  //     // dispatch(loginAuto(user?._id)).then((res) => {
  //     //   setLoadingForm(false)
  //     //   if(user?.is_selling === true) setBankingAvailable(true);
  //     // })
  //   }
  //   else{
  //     setBErrors({'Response': res?.message})
  //     setLoadingForm(false);
  //   }
  // };


  const TAX_CATEGORIES = [
    { value: "digital_art", label: "Digital Art (Downloads)" },
    { value: "digital_services", label: "Custom Service (Commission)" },
    { value: "physical_art", label: "Physical Artwork" },
    { value: "print_on_demand", label: "Print-on-Demand Product" },
    { value: "physical_general", label: "Other Physical Item" },
  ];

  const [newSize, setNewSize] = useState("");
  const [newColor, setNewColor] = useState("");

  useEffect(() => {
    if (editingProduct) setFormData(editingProduct);
  }, [editingProduct]);

  const [errors, setErrors] = useState({});
  const clearError = (field) =>
    setErrors((prev) => {
      const copy = { ...prev };
      delete (copy)[field];
      return copy;
    });

  const validate = () => {
    const newErrors = {};
    if (!formData.productName || formData.productName.toString().trim() === "")
      newErrors.name = "Product name is required";
    if (!formData.taxCategory || formData.taxCategory === "")
      newErrors.category = "Category is required";
    if (formData.type === "physical" && formData.shipping?.shippingCost == null)
      newErrors.deliveryC = "Delivery Charges are required";
    if (
      formData.price == null ||
      isNaN(Number(formData.price)) ||
      Number(formData.price) <= 0
    )
      newErrors.price = "Price must be greater than 0";
    if (
      formData.stock == null ||
      isNaN(Number(formData.stock)) ||
      Number(formData.stock) < 0
    )
      newErrors.stock = "Stock must be 0 or more";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const selectedCategory = categories.find((c) => c.name === formData.category);

  const handleSubmit = (status) => {
    if (status === "published" && !validate()) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      return;
    }
    const product = {
      _id: editingProduct?._id || null,
      userId: user?._id,
      productName: formData.productName || "",
      description: formData.description || "",
      category: formData.category || "",
      subCategory: formData.subCategory,
      taxCategory: formData.taxCategory || 'physical_general',
      price: Number(formData.price) || 0,
      type: formData.type || "physical",
      discountPrice: Number(formData.discountPrice) || 0,
      sku: formData.sku || "",
      stock: Number(formData.stock) || 0,
      images: formData.images || [],
      variants: formData.variants,
      video: formData.video,
      shipping: formData.shipping,
      digitalFile: formData.digitalFile,
      createdAt: "",
      seo: formData.seo,
      status: user?.is_selling ? status : 'draft'
    };

    onSave(product);
  };

  const addSize = () => {
    if (newSize && !formData.variants?.sizes?.includes(newSize)) {
      setFormData({
        ...formData,
        variants: {
          ...formData.variants,
          sizes: [...(formData.variants?.sizes || []), newSize],
        },
      });
      setNewSize("");
    }
  };

  const removeSize = (size) => {
    setFormData({
      ...formData,
      variants: {
        ...formData.variants,
        sizes: formData.variants?.sizes?.filter((s) => s !== size),
      },
    });
  };

  const addColor = () => {
    if (newColor && !formData.variants?.colors?.includes(newColor)) {
      setFormData({
        ...formData,
        variants: {
          ...formData.variants,
          colors: [...(formData.variants?.colors || []), newColor],
        },
      });
      setNewColor("");
    }
  };

  const removeColor = (color) => {
    setFormData({
      ...formData,
      variants: {
        ...formData.variants,
        colors: formData.variants?.colors?.filter((c) => c !== color),
      },
    });
  };

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images?.filter((_, i) => i !== index),
    }));
  };

  const handleFileUpload = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const readers = Array.from(files).map(
      (file) =>
        new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = () => resolve(fr.result);
          fr.onerror = reject;
          fr.readAsDataURL(file);
        })
    );
    Promise.all(readers).then((dataUrls) => {
      setFormData((prev) => ({
        ...prev,
        images: [...(prev.images || []), ...dataUrls],
      }));
    });
    e.currentTarget.value = "";
  };

  return (
    <div>
      <div className="mx-auto" style={{maxWidth: 700}}>
        <div className="">

          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark">{editingProduct ? "Edit Product" : "Add Product"}</h5>
            <div className="d-flex align-items-baseline">
              <p>Add your first product on iBouge</p>&nbsp;<sup className="">®</sup>
            </div>
          </div>

          {/* Basic Info */}
          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark">Basic Information</h5>
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label className="form-label">Product Name *</label>
                <input
                  type="text"
                  value={formData.productName}
                  onChange={(e) => {
                    setFormData({ ...formData, productName: e.target.value });
                    clearError("name");
                  }}
                  className={`form-control ${errors.name ? "border-1 border-danger" : ""
                    } border-radius-3`}
                  placeholder="Enter product name"
                />
                {errors.name && (
                  <p className="text-danger small mt-1">{errors.name}</p>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Product Type *</label>
                <select
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      type: e.target.value,
                    })
                  }
                  className="form-select"
                >
                  <option value="physical">Physical</option>
                  <option value="digital">Digital</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Product Category *</label>
                <select
                  value={formData.taxCategory}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      taxCategory: e.target.value,
                    })
                  }
                  className={`form-select ${errors.taxCategory ? "border-danger" : ""
                    }`}
                >
                  <option value="">Select product type</option>

                  {TAX_CATEGORIES.map((cat) => (
                    <option key={cat.value} value={cat.value}>
                      {cat.label}
                    </option>
                  ))}
                </select>

                <label className="form-label mt-2">
                  Choose what best describes your product. This helps apply correct taxes.
                </label>

                {errors.taxCategory && (
                  <p className="text-danger small mt-1">
                    {errors.taxCategory}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Pricing */}
          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark">Pricing & Stock</h5>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Price ($) *</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.price}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      price: parseFloat(e.target.value),
                    })
                  }
                  className={`form-control ${errors.price ? "border-1 border-danger" : ""
                    } border-radius-3`}
                  placeholder="0.00"
                />
                {errors.price && (
                  <p className="text-sm text-red-600 mt-1">{errors.price}</p>
                )}
              </div>

              <div className="col">
                <label className="block text-sm mb-2">Delivery Charges ($) *</label>
                <input
                  type="number"
                  value={formData.shipping?.shippingCost}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      shipping: {
                        ...formData.shipping,
                        shippingCost: parseFloat(e.target.value),
                      },
                    })
                  }
                  className={`form-control ${errors.deliveryC ? "border-1 border-danger" : ""
                    } border-radius-3`}
                />
                {errors.deliveryC && (
                  <p className="text-sm text-red-600 mt-1">{errors.deliveryC}</p>
                )}
              </div>

              <div className="col">
                <label className="block text-sm mb-2">Stock Quantity *</label>
                <input
                  type="number"
                  value={formData.stock}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      stock: parseInt(e.target.value),
                    })
                  }
                  className={`form-control ${errors.stock ? "border-1 border-danger" : ""
                    } border-radius-3`}
                  placeholder="0"
                />
                {errors.stock && (
                  <p className="text-sm text-red-600 mt-1">{errors.stock}</p>
                )}
              </div>
            </div>
          </div>

          {/* Variants */}
          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark">Variants (Optional)</h5>

            {/* Sizes */}
            <div className="mb-2">
              <label className="form-label">Sizes</label>

              <div className="d-flex gap-2 mb-3">
                <input
                  type="text"
                  value={newSize}
                  onChange={(e) => setNewSize(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && addSize()}
                  className="form-control"
                  placeholder="e.g., S, M, L, XL"
                />

                <button
                  type="button"
                  onClick={addSize}
                  className="btn ib-btn px-4"
                >
                  <MdAdd className="text-white"/>
                </button>
              </div>

              <div className="d-flex flex-wrap gap-2">
                {formData.variants?.sizes?.map((size) => (
                  <span
                    key={size}
                    className="d-inline-flex align-items-center gap-2 px-3 py-1 border border-dark rounded-pill small"
                  >
                    {size}
                    <button
                      type="button"
                      onClick={() => removeSize(size)}
                      className="btn btn-link text-secondary p-0 text-decoration-none"
                    >
                      <FiX className="" />
                    </button>
                  </span>
                ))}
              </div>
            </div>

            {/* Colors */}
            <div>
              <label className="form-label">Colors</label>
              <div className="d-flex gap-2 mb-3">
                <input
                  type="text"
                  value={newColor}
                  onChange={(e) => setNewColor(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && addColor()}
                  className="form-control"
                  placeholder="e.g., Black, White, Red"
                />
                <button
                  type="button"
                  onClick={addColor}
                  className="btn ib-btn px-4"
                >
                  <MdAdd className="text-white"/>
                </button>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {formData.variants?.colors?.map((color) => (
                  <span
                    key={color}
                    className="d-inline-flex align-items-center gap-2 px-3 py-1 border border-dark rounded-pill small"
                  >
                    {color}
                    <button
                      type="button"
                      onClick={() => removeColor(color)}
                      className="btn btn-link text-secondary p-0 text-decoration-none"
                    >
                      <FiX className="" />
                    </button>
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark mb-2">Product Images</h5>

            <div className="row row-cols-2 row-cols-md-4 g-4">
              {formData.images?.map((img, index) => (
                <div key={index} className="col">
                  <div className="position-relative">
                    <ModalImage
                      small={img}
                      large={img}
                      alt={`Product ${index + 1}`}
                      className="img-fluid w-100 rounded-3 object-fit-cover"
                      imageBackgroundColor="transparent"
                    />

                    <button
                      type="button"
                      onClick={() => removeImage(index)}
                      className="position-absolute top-0 end-0 m-2 p-1 bg-danger text-white rounded-circle border-0"
                      style={{ cursor: "pointer" }}
                    >
                      <FiX />
                    </button>
                  </div>
                </div>
              ))}

              <div className="col">
                <div
                  className="border border-2 border-dashed rounded-3 d-flex align-items-center justify-content-center text-center"
                  style={{
                    aspectRatio: "1 / 1",
                    cursor: "pointer",
                    borderColor: "#dee2e6",
                    transition: "border-color 0.2s",
                  }}
                  onClick={() => imageRef.current?.click()}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#0d6efd")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#dee2e6")}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      imageRef.current?.click();
                  }}
                >
                  <div>
                    {/* <Upload className="mb-2 text-secondary" size={32} /> */}
                    <p className="small text-secondary mb-0">Upload Image</p>
                  </div>
                </div>
              </div>
            </div>

            <input
              ref={imageRef}
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
          </div>

          {/* Digital File (Digital Products Only) */}
          {formData.type === "digital" && (
          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark mb-2">Digital File</h5>

            <div>
              <label className="form-label">File Name/URL</label>
              <input
                type="text"
                value={formData.digitalFile || ""}
                onChange={(e) =>
                  setFormData({ ...formData, digitalFile: e.target.value })
                }
                className="form-control"
                placeholder="e.g., product-file.pdf"
              />
            </div>
          </div>
          )}

          {/* Description */}
          <div className="bg-white p-3 mt-3 rounded-3">
            <h5 className="text-dark mb-2">Description</h5>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              rows={6}
              className="form-control"
              placeholder="Describe your product..."
            />
          </div>

          {/* Action Buttons */}
          <div className="d-flex gap-4 border-top mt-3">
            <button
              type="button"
              onClick={() => handleSubmit("draft")}
              className="btn ib-btn text-white flex-fill py-3"
              style={{ transition: "background-color 0.2s", cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#000")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "")}
            >
              Continue to payment method
            </button>
          </div>

        </div>
      </div>

    </div>
  );
}